import { Button, Card, Modal, Select, Tag } from 'antd';
import { useToast } from 'components/Toast';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCourseId, selectListCourses, selectListCoursesBase, selectListPeriod } from 'store/common/shared/selectors';
import { RESPONSE_MESSAGE } from 'store/initiativeAchievement/constants/initiativeAchievement.constants';
import { InitiativeAchievementHttp } from 'store/initiativeAchievement/services/initiativeAchievement.http';
import _ from 'lodash';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { LocalStorageKey, LocalStorageService } from 'services/localStorage.service';
import type { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { DownOutlined } from '@ant-design/icons';
import { getCourseId } from 'store/common/shared/saga';
import UploadFile from 'utils/uploadfile';
import { AppHelper } from 'utils/app.helpers';
import FunctionUtils from 'utils/FunctionUtils';
import { CommonHttp } from 'store/common/services/common.http';


const Container = styled.div`
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  margin-bottom: 10px;
`;

const StyleSelectPeriod: typeof Select = styled(Select)`
  height: 40px;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  border-radius: 5px;
  &:hover > div {
    cursor: pointer !important;
  }
  & .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    & .ant-select-selection-search {
        height: 40px !important;
     }
     & .ant-select-selection-search-input {
        height: 40px !important;
     }
     & .ant-select-selection-item {
        line-height: 40px !important;
     }
     & .ant-select-selection-placeholder {
        line-height: 40px !important;
     }
    }
    
}
` as any;
const IconDropdown = styled.span`
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 11px;
  display: flex;
  align-items: center;
  height: 12px;
  margin-top: -6px;
  color: rgba(0, 0, 0, 0.25);
  font-size: 12px;
  line-height: 1;
  text-align: center;
  pointer-events: none;
`;

const StyleSelectCourse: typeof Select = styled(Select)`
  height: 40px;
  box-shadow: 0 4px 6px -1px rgb(113 126 195 / 10%), 0 2px 4px -2px rgb(113 126 195 / 10%);
  border-radius: 5px;
  & .ant-select-selector {
    height: 40px !important;
    border-radius: 5px !important;
    & .ant-select-selection-search {
        height: 40px !important;
     }
     & .ant-select-selection-search-input {
        height: 40px !important;
     }
     & .ant-select-selection-item {
        line-height: 40px !important;
     }
     & .ant-select-selection-placeholder {
        line-height: 40px !important;
     }
    }
  }
` as any;

interface IModal {
  isOpen: boolean;
  handleCancel: () => void;
  title?: string;
  id?: string;
  handleRefresh: () => void;
  courseId?: number;

  file?: any;
  comment?: string;
  idUser?: number;
  detail?: any;
  proofValue?: any;
  handleSuccess?: (fileName: any[], comment: string, id: string) => void;
}

const { Option } = Select;
function ModalCreateReview({ isOpen, title, handleCancel, handleRefresh, detail, handleSuccess}: IModal) {
  const toast = useToast();
  const listCourse: any = useSelector(selectListCourses);
  const listCourseBase: any = useSelector(selectListCoursesBase);
  const listPeriod: any = useSelector(selectListPeriod);
  const [yearSchool, setYearSchool] = useState<string>('');
  const [titleReview, setTitleReview] = useState<string>('');
  const [period, setPeriod] = useState<any[]>([]);
  const courseId: any = useSelector(selectCourseId);

  const [description, setDescription] = useState<string>('');
  //const [effectScopeId, seteffectScopeId] = useState<Number>(0);
  const [effectScopeId, setEffectScopeId] = useState(0);
  const [score, setScore] = useState<Number>(0);

  const [files, setFiles] = useState<any[]>([]);
  const [filePath, setFilePaths] = useState<any[]>([]);
  const [note, setNote] = useState<string>('');
  const [isIOpenModalConfirm, setIsOpenModalConfirm] = useState<boolean>(false);
  const commonHttp = new CommonHttp();

  const navigate = useNavigate();
  const localStorage = new LocalStorageService();
  const initiativeAchievementHttp = new InitiativeAchievementHttp();

  const onSelectYear = (value: string): void => {
    setYearSchool(value);
  };

  // const onSelectEffect = (value: Number): void => {
  //   setEffectScopeId(value);
  // };
  const onSelectEffect = (value) => {
    setEffectScopeId(value);
  };
  const onChangeValue = (e) => {
    if(e.target.name == 'title'){
      setTitleReview(e.target.value);
    }
    if(e.target.name == 'description'){
      setDescription(e.target.value);
    }
    if(e.target.name == 'score'){
      setScore(e.target.value);
    }
    if(e.target.name == 'effectScope'){
      setEffectScopeId(e.target.value);
    }
  };

  const handleUpload = () => {
    if (!_.isEmpty(filePath)) {
      commonHttp.uploadFile(filePath).then((res) => {
        try {
          if (res.ok) {
            let valueOfKeys: any[] = Object.keys(res.data.data.presigned_urls).map((key) => ({
              [key]: res.data.data.presigned_urls[key]
            }));
            valueOfKeys.map((item: any, idx: number) => UploadFile.uploadFileImgS3(item, files));
          }
        } catch (error) {
          console.log(error);
        }
      });
    }
    if (handleSuccess) {
      handleSuccess(filePath, note, detail);
    }
    //toast?.pushSuccess('Dữ liệu đã được lưu tạm!');
    //handleCancel();
  };

  const handleSubmit = (e) => {
    if (titleReview == '' || effectScopeId == 0 || description == '' || score == 0) {
      toast?.pushWarning(RESPONSE_MESSAGE.WARN.ADD_INITIATIVE_SUCCESS);
      return;
    }
    if (yearSchool == null) {
      toast?.pushWarning("Khóa học không tồn tại. Vui lòng kiểm tra lại thông tin.");
      return;
    }
    //var file = _.keyBy(filePath);
    const obj = Object.assign({}, filePath); // array to object
    //upload
    handleUpload();
    ///
    const request = {
      title: titleReview,
      courseId: parseInt(yearSchool),
      description: description,
      effect_scope_id: parseInt(effectScopeId.toString()),
      files: obj,
      score: parseInt(score.toString()),
      phan_loai: 0, // 0 bổ sung, 1 đăng ký
    };
    
    initiativeAchievementHttp.addInitiative(request).then((res) => {
      if (res.ok && res.status === 200) {
        toast?.pushSuccess(RESPONSE_MESSAGE.SUCCESS.PLUS_INITIATIVE_SUCCESS);
        handleCancel();
        handleRefresh();
        //navigate(`/manager-review/create-standard/${res.data.data.evaluation.id}/${0}`);
        //localStorage.setItem({ key: LocalStorageKey.isVisible, value: 'show' });
      } else {
        toast?.pushError(RESPONSE_MESSAGE.FAIL.PLUS_INITIATIVE_FAIL);
      }
    });
  };

  const handleChange = (value: string[]) => {
    setPeriod(value);
  };


  const tagRender = (props: CustomTagProps) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3, fontSize: '14px', fontWeight: '400', lineHeight: '25px' }}>
        {label}
      </Tag>
    );
  };

  // upload
  // useEffect(() => {
  //   if (!_.isEmpty(detail)) {
  //     if (detail.evidence_files_self) {
  //       setFilePaths(Object.values(detail.evidence_files_self));
  //     } else {
  //       setFilePaths([]);
  //     }
  //     setNote(detail.evidence_content_self);
  //   }
  // }, [detail]);

  const handleImage = (e: React.ChangeEvent<HTMLInputElement>) => {      
    const fileArr = Array.from(e.target.files || []);
    const newFilePath: any[] = [...filePath];
    setFiles([
      ...files,
      ...fileArr.map((file) => {
        let key = UploadFile.getIdFile(file, detail);
        newFilePath.push(key);
        return {
          fileName: file.name,
          type: file.type,
          size: file.size,
          fileContents: file,
          key: key
        };
      })
    ]);
    setFilePaths(newFilePath);
  };

  
  const handleRemoveFile = (file: any) => {
    const newFilePath = filePath.filter((item) => item !== file);
    setFilePaths(newFilePath);
  };

  const onChangeNote = (e) => {
    setNote(e.target.value);
  };

  const handleDownLoad = (filePath: string) => {
    AppHelper.createDownloadFile(filePath);
  };
  //////

  return (
    <Modal
      title="Cập nhật sáng kiến"
      centered
      visible={isOpen}
      onCancel={() => handleCancel()}
      width={800}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>,
        <Button key="submit" size="large" type="primary" onClick={handleSubmit}>
          Lưu
        </Button>
      ]}>
      <Container>
        <Card>
          <div className="grid sm:grid-3 gap-15 sm:gap-20">
            <span></span>
              {/* <label htmlFor="" className="font-bold mb-10 block">
                Năm học
              </label> */}
              <div className="relative">
                <StyleSelectCourse
                  style={{
                    width: '100%'
                  }}
                  placeholder="Chọn năm học"
                  onChange={onSelectYear}>
                  {!_.isEmpty(listCourseBase) &&
                    _.orderBy(listCourseBase, ['name'],['desc']).map((item) => (
                      <Option value={item.id} key={item.id}>
                        {item.description}
                      </Option>
                    ))}
                </StyleSelectCourse>
              </div>
             <span></span>
          </div>
          <div className="mb-15">
            <label htmlFor="" className="font-bold mb-10 block">
              Tên sáng kiến
            </label>
            <input
              name="title"
              id="title"
              type="text"
              className="w-full h-44 font-montserrat border-1 text-15 placeholder:text-999 border-solid border-cbce shadow-lg rounded-5 px-15"
              placeholder="Nhập thông tin"
              onChange={onChangeValue}
              value={titleReview}
            />
          </div>
          <div className="mb-15">
              <label htmlFor="" className="font-bold mb-10 block">
                Tóm tắt mô tả sáng kiến
              </label>
              <textarea
                //defaultValue={dataDetail?.self_evaluation_detail?.evaluation_self?.comment_strong}
                id="description"
                name="description"
                onChange={ onChangeValue}
                cols={30}
                rows={3}
                className="p-15 border-1 border-solid border-cbce rounded-10 shadow-lg w-full"
                placeholder="Nhập thông tin">
              </textarea>
          </div>       
          <div className="grid sm:grid-2 gap-15 sm:gap-20">
            <div>
              <label htmlFor="" className="font-bold mb-10 block">
                Nhập điểm
              </label>
              <input
                type="number"
                id="score"
                name="score"
                className="w-full h-44 font-montserrat border-1 text-15 placeholder:text-999 border-solid border-cbce shadow-lg rounded-5 px-15"
                onChange={onChangeValue}
                placeholder="0"
              />
            </div>
            <div className="grid sm:grid-1 gap-15 sm:gap-20">
            <div>
                <label htmlFor="" className="font-bold mb-10 block">
                Chọn phạm vi ảnh hưởng
                </label>
                <div className="relative">
                  <StyleSelectCourse
                    style={{
                      width: '100%'
                    }}
                    id="effectScope"
                    placeholder="--- Chọn --- "
                    onChange={onSelectEffect}>
                    <Option value={1} key={1}> Cấp Quận</Option>
                    <Option value={2} key={2}> Thành phố</Option>
                  </StyleSelectCourse>
                </div>
              </div>
            </div>
          </div>
          <div className="grid sm:grid-1 pt-20 gap-15 sm:gap-20">
              <input type="file" multiple onChange={handleImage} />
          </div>
          <div className="grid sm:grid-3 gap-15 sm:gap-20">
            <ul className="mt-20 flex flex-column gap-10 sm:span-2">
              {!_.isEmpty(filePath) ? (
                filePath?.map((item: any, index) => (
                  <li
                    className="flex items-center justify-between text-45a"
                    key={index}
                    style={{ cursor: 'pointer' }}>
                    <span onClick={() => handleDownLoad(item)} className="text-wrap">
                      <i className="fas fa-file mr-5"></i> {FunctionUtils.TileImg(item)}
                    </span>
                    <button
                      className="border-0 pl-20 text-quinary text-19 bg-transparent remove"
                      style={{ fontSize: '14px' }}
                      onClick={() => handleRemoveFile(item)}>
                      <i className="fas fa-trash text-ea5" />
                    </button>
                  </li>
                ))
              ) : (
                <span>Không có file đính kèm</span>
              )}
            </ul>
            <span></span>
          </div>
        </Card>
      </Container>
    </Modal>
  );
}

export default ModalCreateReview;
